<template>
  <TsCard
    :append-class="`flex flex-col max-md:p-2 h-full ${appendClass}`"
    footer-class="mt-auto"
    dataTestid="blogs-news-and-advice-card-blogs"
    noBorder
    noShadow
  >
    <template #header>
      <NuxtLinkWithLocale class="block" :to="data?.url">
        <div class="h-[105px] overflow-hidden">
          <TsImage
            :src="`${data?.blogImage}?format=webp`"
            :alt="data?.title"
            title=""
            class="rounded-lg w-full h-full"
            width="1063"
            height="717"
            dataTestid="blogs-news-and-advice-hero-banner-blog"
            loading="lazy"
          />
        </div>
      </NuxtLinkWithLocale>
    </template>
    <template #content>
      <NuxtLinkWithLocale class="block" :to="data?.url">
        <TsTypography
          append-class="mb-0 text-idle-black line-clamp-1"
          weight="bold"
          dataTestid="blogs-news-and-advice-blog-title-typo"
          >{{ data?.title }}</TsTypography
        >
      </NuxtLinkWithLocale>
      <TsTypography
        append-class="mb-2 w-full line-clamp-3"
        dataTestid="blogs-news-and-advice-excerpt-data-typo"
      >
        {{ data?.excerpt }}
      </TsTypography>
      <TsTypography
        size="sm"
        append-class="mt-auto mb-0 flex items-center"
        dataTestid="blogs-news-and-advice-news-typography-hours"
      >
        {{ formatDate(data?.publishDate) }}
      </TsTypography>
    </template>
    <template #footer v-if="!hideReadMore">
      <NuxtLinkWithLocale :to="data?.url">
        <TsTypography
          weight="bold"
          dataTestid="blogs-news-and-advice-read-more-typo-blogs"
          append-class="underline mb-0 underline-offset-2 cursor-pointer text-info"
        >
          {{useTranslation('readMore','Lees meer')}}
        </TsTypography>
      </NuxtLinkWithLocale>
    </template>
  </TsCard>
</template>

<script setup lang="ts">
import { useTranslation } from "~/composables/useTranslation";
import { formatDate } from "~/utils/formatDateAndTime";

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type Data = {
  id: number;
  title: string;
  excerpt: string;
  url: string;
  blogImage: string;
};

type Props = {
  dataTestid: string;
  data: Data;
  appendClass?: string;
  hideReadMore?: boolean;
};

const props = withDefaults(defineProps<Props>(), {});
</script>
